import React, { Component } from 'react';
import { connect } from 'react-redux';

import _ from 'i18n';
import TypeEmails from "./TypeEmails";
import Preview from "./email/Preview";
import Editor from "./email/Editor";
import { ucFirst } from 'utils';
import Test from './email/Test';
import Warning from './Warning';
import TypeEmailsFetching from "../../fetching/TypeEmailsFetching";
import { setThemeLanguage } from "actions";
import CheckBoxBtn from "../../common/CheckBoxBtn";
import AddTypeModal from "./AddTypeModal";
import TTPModal from "../../ui/TTPModal";
import TTPLoader from "../../ui/TTPLoader";
import { onSuccess, onError } from "utils";
import { SVG_ICONS } from "Common";
import { toast } from "react-toastify";
import { removeTypeFromCurrentSetting, deleteGenericEmailType } from "thunks";
import { postResizeMessage } from '../../../services/utils';

class EmailsList extends Component {

  resizerTimeOutId = null;

  state = {
    activeTypes: [],
    emails: [],
    isVisible: 'NONE',
    showAddTypeModal: false,
    editType: null,
    pendingDeleteType: null,
    deleting: false,
  };

  componentDidMount() {
    this.props.fetchEmails(this.props.settingsId);
    postResizeMessage();
    this.props.setThemeLanguage(null);

  }

  componentDidUpdate(prevProps) {
    const { emails } = this.props;
    if (emails !== prevProps.emails) {
      const items = emails.reduce((rv, ge) => {
        rv[ge.targetType] = rv[ge.targetType] || [];
        rv[ge.targetType][ge.language] = ge;
        return rv;
      }, {});
      this.setState({ emails: items });
      setTimeout(postResizeMessage, 300);
    }
  }

  setActiveTypes = (isVisible, type = null) => {
    const { types } = this.props;
    const { activeTypes } = this.state;

    switch (isVisible) {
      case "NONE":
        this.setState({ activeTypes: [], isVisible: "NONE" });
        break;
      case "ALL":
        this.setState({ activeTypes: (types.map(currentType => currentType.id)), isVisible: "ALL" });
        break;
      case "ONE": {
        if (activeTypes.some((tid) => tid === type)) {
          this.setState(
            { activeTypes: activeTypes.filter(tid => tid !== type), isVisible: "ONE" }
          );
        } else {
          this.setState({ activeTypes: [...activeTypes, type], isVisible: "ONE" });
        }
        break;
      }
    }
    clearTimeout(this.resizerTimeOutId);
    this.resizerTimeOutId = setTimeout(postResizeMessage, 1000);
  };

  renderWarningData() {
    const { types, languages, userLanguage, fetching } = this.props;
    const { emails } = this.state;
    if (fetching || !types || !types.length) {
      return null;
    }
    let warnings = [];
    let sortedTypes = this.handleSortTypes(types);
    sortedTypes.forEach(type => {
      const activeLanguages = Object.keys(emails[type.id] ? emails[type.id] : []) || [];
      const unavailableLanguages = languages.filter(lng => activeLanguages.indexOf(lng) < 0);
      if (unavailableLanguages && unavailableLanguages.length) {
        warnings.push(
          <Warning
            key={type.id}
            languages={unavailableLanguages}
            label={type[`label${ucFirst(userLanguage)}`]}
            required={type.required}
            clicked={() => this.handleWarningNoteClick(type)}
          />
        );
      }
    });

    return warnings;
  }

  handleWarningNoteClick = (type) => {
    const { activeTypes } = this.state;
    const element = document.getElementById(type.id);
    element.scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
    if (activeTypes !== type.id) {
      this.setActiveTypes("ONE", type.id);
    }
  };

  handleSortTypes = (types) => {
    return types.sort((a, b) => (a.rank > b.rank) ? 1 : -1)
  };

  renderGenericEmailItem = () => {
    const { types, fetching, languages, settingsId } = this.props;
    const { emails, activeTypes } = this.state;

    let sortedTypes = this.handleSortTypes(types);

    if (fetching) {
      return <TypeEmailsFetching />;
    }
    return sortedTypes.map((type, i) => (
      <TypeEmails
        id={emails[type] ? emails[type]["id"] : null}
        key={`type-${i}`}
        settingsId={settingsId}
        emails={emails[type.id] ? emails[type.id] : []}
        languages={languages}
        active={activeTypes.some(t => t === type.id)}
        type={type}
        onToggleActive={() => this.setActiveTypes("ONE", type.id)}
        onPreview={this.showPreview}
        onEdit={this.openEditTypeModal}
        onDelete={this.requestDeleteType}
        isUAVersion={this.props.isUAVersion}
      />
    )
    )
  };

  toggleShowAll = (e) => {
    const { isVisible } = this.state;
    const allVisible = isVisible === "ALL";
    this.setActiveTypes(allVisible ? "NONE" : "ALL");
    e.stopPropagation();
    e.preventDefault();
  };

  openAddTypeModal = () => this.setState({ showAddTypeModal: true });

  closeAddTypeModal = () => this.setState({ showAddTypeModal: false });

  openEditTypeModal = (type) => this.setState({ editType: type });

  closeEditTypeModal = () => this.setState({ editType: null });

  handleTypesAdded = () => {
    this.props.fetchEmails(this.props.settingsId);
  };

  requestDeleteType = (type) => this.setState({ pendingDeleteType: type });

  cancelDeleteType = () => this.setState({ pendingDeleteType: null });

  // scope: "global" = delete the catalog type definitely; "config" = remove it
  // from the current config only.
  confirmDeleteType = (scope) => {
    const { pendingDeleteType } = this.state;
    if (!pendingDeleteType) {
      return;
    }
    const { targetApp } = this.props;
    const code = pendingDeleteType.id;
    const app = pendingDeleteType.targetApp || targetApp;

    this.setState({ deleting: true });
    // Delete on the backend with the chosen scope, then drop it from this
    // record's `types` JSON so the row disappears.
    this.props.deleteCatalogType(code, app, scope).then(
      (res) => {
        // The backend may return its failure (in-use / not-found) as a normal
        // response body rather than an HTTP error — detect it before removing.
        const notif = this.getKnownDeleteNotif(res && res.value && res.value.data);
        if (notif) {
          this.setState({ deleting: false, pendingDeleteType: null });
          this.showDeleteNotif(notif);
          return;
        }
        this.props.removeType(code).then(
          (removeRes) => {
            this.setState({ deleting: false, pendingDeleteType: null });
            onSuccess(removeRes);
            this.props.fetchEmails(this.props.settingsId);
          },
          () => {
            this.setState({ deleting: false });
            onError();
          }
        );
      },
      (err) => {
        this.setState({ deleting: false, pendingDeleteType: null });
        this.notifyDeleteError(err);
      }
    );
  };

  // The delete endpoint returns one of two known failure messages:
  //  - "... is still in use."   → the code is referenced by another config
  //  - "... does not exist."    → the type was already removed
  // Match on the stable part of each message and map to a translated notif.
  getKnownDeleteNotif = (data) => {
    if (!data) {
      return null;
    }
    // `errors` may be an array (`[{message}]`) or an object (`{message}`).
    const errors = data.errors;
    let message = "";
    if (Array.isArray(errors) && errors.length) {
      message = errors[0].message || errors[0].code || "";
    } else if (errors && typeof errors === "object") {
      message = errors.message || errors.code || "";
    }
    if (!message) {
      message = data.message || "";
    }
    const text = `${message}`.toLowerCase();

    if (text.indexOf("still in use") > -1) {
      return { title: "type_in_use_title", body: "type_in_use_message" };
    }
    if (text.indexOf("does not exist") > -1) {
      return { title: "type_not_found_title", body: "type_not_found_message" };
    }
    return null;
  };

  showDeleteNotif = (notif) => {
    toast.error(
      <div className="toast-content">
        <div className="toast-title">{_(notif.title)}</div>
        <div className="toast-body">{_(notif.body)}</div>
      </div>,
      { toastId: "delete-type-notif" }
    );
  };

  notifyDeleteError = (err) => {
    const notif = this.getKnownDeleteNotif(
      err && err.response && err.response.data
    );
    if (notif) {
      this.showDeleteNotif(notif);
    } else {
      toast.error(_("delete_type_error"), { toastId: "delete-type-error" });
    }
  };


  render() {
    const { fetching, onReset, userLanguage } = this.props;
    const {
      isVisible,
      showAddTypeModal,
      editType,
      pendingDeleteType,
      deleting,
    } = this.state;
    const allVisible = isVisible === "ALL";
    const deleteLabel =
      pendingDeleteType &&
      (pendingDeleteType[`label${ucFirst(userLanguage)}`] || pendingDeleteType.id);
    let warnings = this.renderWarningData();
    return (
      <div className="email-list-step">
        <div className="sidebar__actions">
          <div className="row">
            {(!fetching && warnings && warnings.length > 0) && <div className="columns small-12 sidebar__warning">
              <h5><i className="icon-left icon-pin" />{_('UnavailableLanguagesNote')}</h5>
              <div className="row notes-container">
                {warnings}
              </div>
            </div>
            }
            <div className="columns small-12 emails-actions">
              <button className="add-type-btn" onClick={this.openAddTypeModal}>
                <i className='icon icon-plus' />
                {ucFirst(_('add_a_type'))}
              </button>
              <button onClick={onReset}>
                <i className='icon  icon-reload' />
                {ucFirst(_('reset emails'))}
              </button>
              <button onClick={this.toggleShowAll}>
                <CheckBoxBtn label={ucFirst(_('show all'))} checked={allVisible ? "ALL" : ""} />
              </button>
            </div>
          </div>
        </div>
        {this.renderGenericEmailItem()}
        {/* email actions*/}
        <Test />
        <Preview isUAVersion={this.props.isUAVersion} />
        <Editor isUAVersion={this.props.isUAVersion} />
        {showAddTypeModal && (
          <AddTypeModal
            onClose={this.closeAddTypeModal}
            onAdded={this.handleTypesAdded}
          />
        )}
        {editType && (
          <AddTypeModal
            editType={editType}
            onClose={this.closeEditTypeModal}
            onAdded={this.handleTypesAdded}
          />
        )}
        {pendingDeleteType && (
          <TTPModal
            isOpen={true}
            onClose={deleting ? () => {} : this.cancelDeleteType}
            modalStyle={{ content: { width: "90%", maxWidth: "460px", height: "auto" } }}
            shouldNotCloseOnOverlayClick={true}
          >
            <div className="delete-type-confirm">
              <div className="delete-type-confirm__header">
                <img
                  className="delete-type-confirm__header-icon"
                  src={"/img/icons/" + SVG_ICONS["TRASH"]}
                  alt=""
                />
                <span className="delete-type-confirm__header-title">
                  {_("delete_type_title")}
                </span>
              </div>
              {deleting && (
                <div className="delete-type-confirm__loader">
                  <TTPLoader cssClass="delete-type-confirm__loader-ripple" />
                </div>
              )}
              <p className="delete-type-confirm__message">
                {_("delete_type_confirm")}
                <strong> {deleteLabel}</strong> ?
              </p>
              <div className="delete-type-confirm__choices">
                <button
                  className="delete-type-confirm__choice"
                  onClick={() => this.confirmDeleteType("config")}
                  disabled={deleting}
                >
                  <span className="delete-type-confirm__choice-title">
                    {_("delete_type_config_title")}
                  </span>
                  <span className="delete-type-confirm__choice-desc">
                    {_("delete_type_config_desc")}
                  </span>
                </button>
                <button
                  className="delete-type-confirm__choice delete-type-confirm__choice--danger"
                  onClick={() => this.confirmDeleteType("global")}
                  disabled={deleting}
                >
                  <span className="delete-type-confirm__choice-title">
                    {_("delete_type_global_title")}
                  </span>
                  <span className="delete-type-confirm__choice-desc">
                    {_("delete_type_global_desc")}
                  </span>
                </button>
              </div>
              <div className="delete-type-confirm__actions">
                <button className="cancel" onClick={this.cancelDeleteType} disabled={deleting}>
                  {ucFirst(_("cancel"))}
                </button>
              </div>
            </div>
          </TTPModal>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  emails: state.genericEmail.currentSetting.emails.items,
  settingsId: state.genericEmail.currentSetting.id,
  types: state.genericEmail.currentSetting.types || [],
  languages: state.genericEmail.currentSetting.languages,
  targetApp: state.genericEmail.currentSetting.targetApp,
  fetching: state.genericEmail.currentSetting.emails.fetching,
  activeLanguage: state.themes.filter.language,
  userLanguage: state.params.lng
});
const mapDispatchToProps = (dispatch) => ({
  setThemeLanguage: (lng) => dispatch(setThemeLanguage(lng)),
  removeType: (typeId) => dispatch(removeTypeFromCurrentSetting(typeId)),
  deleteCatalogType: (code, targetApp, scope) =>
    dispatch(deleteGenericEmailType(code, targetApp, scope)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EmailsList);
